import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
	{
		path: '',
		redirectTo: 'equipment',
		pathMatch: 'full'
	},
	{
		path: 'equipment',
		loadChildren: () => import('./modules/equipments/equipment.module').then(m => m.EquipmentModule)
	},
	{
		path: 'article',
		loadChildren: () => import('./modules/articles/article.module').then(m => m.ArticleModule)
	},
	{
		path: 'software',
		loadChildren: () => import('./modules/software/software.module').then(m => m.SoftwareModule)
	},
	{
		path: 'configuration',
		loadChildren: () => import('./modules/configuration/configuration.module').then(m => m.ConfigurationModule)
	},
	{
		path: 'static-page',
		loadChildren: () => import('./modules/static-page/static-page.module') // eslint-disable-line
			.then(module => module.StaticPageModule)
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
